import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {SharedModule} from '../../../../shared/shared.module';
import {NgStyle} from '@angular/common';
import {RegisterStep1Component} from './register-step1/register-step1.component';
import {BaseForm} from '../../../base/components/base-form.component';
import {Candidat} from '../../../candidat/models/candidat.model';
import {Register} from '../../auth.model';

@Component({
  selector: 'app-register',
  standalone: true,
    imports: [
        RouterLink,
        SharedModule,
        NgStyle,
        RegisterStep1Component,
        RouterOutlet
    ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent extends BaseForm<Register> implements OnInit{

  public show = false;

  constructor() {
      super('/');
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
  }

  // tslint:disable-next-line:typedef
  showPassword() {
    this.show = !this.show;
  }

}
